import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Clients = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  const clientImages = [
    { src: "clients/bet.webp", alt: "Bet" },
    { src: "clients/glit.webp", alt: "Glitstudio" },
    { src: "clients/okko.png", alt: "Okko" },
    { src: "clients/skilcamp.png", alt: "Skilcamp" },
    { src: "clients/niyo.png", alt: "Niyo" },
    { src: "clients/mpocket.png", alt: "Mpocket" },
    { src: "clients/bet22.jpg", alt: "Bet22" },
    { src: "clients/rupee112.jpg", alt: "Rupee112" },
  ];

  return (
    <div className="px-5 xl:px-0 max-w-screen-xl mx-auto">
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlaySpeed={2000}
        autoPlay={true}
        arrows={false}
      >
        {clientImages.map((client, index) => (
          <div key={index} className="max-w-sm p-6 mx-3">
            <div className="flex justify-center mb-4">
              <img
                src={client.src}
                alt={client.alt}
                className="w-20 h-20 rounded-full object-contain border border-gray-200 shadow"
              />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Clients;
